<template>
  <div class="row">
    <div
      class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-primary"
      v-if="data.length > 0"
      v-for="(profile, rowIndex) in data"
      :key="'row' + rowIndex"
    >
      <job-card
        :id="id"
        :profile="profile"
        :actions="actions"
        @action-grid-view-table="getAction"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "JobGrid",
  props: ["id", "data", "actions"],
  methods: {
    getAction(row, action, active) {
      this.$emit("getCardAction", row, action, active);
    },
  },
};
</script>
